import { getPortalTarget } from "@circle-react-shared/uikit/TipTap/utilities/getPortalTarget";
import { createCompassSuggestionRenderer } from "@circle-react-uikit/TipTap/Extensions/CustomExtensions/createCompassSuggestionRenderer";
import { Extension } from "@tiptap/core";
import { PluginKey } from "@tiptap/pm/state";
import { ReactRenderer } from "@tiptap/react";
import Suggestion from "@tiptap/suggestion";
import tippy from "tippy.js";

import { CompassEmojiList } from "./CompassEmojiList";
import { EmojiPicker } from "./EmojiPicker";

interface InlineEmojiExtensionOptions {
  frameDocument: Document | null;
  portalTargetId: string | null;
  useCompassSuggestionMenu: boolean;
}

export const InlineEmojiExtension =
  Extension.create<InlineEmojiExtensionOptions>({
    name: "inlineEmoji",
    addOptions() {
      return {
        portalTargetId: null,
        frameDocument: null,
        useCompassSuggestionMenu: false,
      };
    },
    addProseMirrorPlugins() {
      const appendTarget = getPortalTarget(
        this.options.portalTargetId,
        this.options.frameDocument,
      );
      const targetDocument = this.options.frameDocument || document;
      return [
        Suggestion({
          editor: this.editor,
          char: ":",
          pluginKey: new PluginKey("emoji"),
          render: () => {
            let reactRenderer: any;
            let popup: any;

            if (this.options.useCompassSuggestionMenu) {
              return createCompassSuggestionRenderer(CompassEmojiList, {
                targetDocument,
              });
            }

            return {
              onStart: props => {
                reactRenderer = new ReactRenderer(EmojiPicker, {
                  props,
                  editor: props.editor,
                });

                const getReferenceClientRect = () =>
                  props.clientRect?.() || new DOMRect(0, 0, 0, 0);

                popup = tippy(appendTarget, {
                  getReferenceClientRect,
                  content: reactRenderer.element,
                  appendTo: () => appendTarget || targetDocument.body,
                  showOnCreate: true,
                  interactive: true,
                  trigger: "manual",
                  placement: "auto-end",
                  theme: "light-border",
                });
              },

              onUpdate(props) {
                reactRenderer.updateProps(props);

                popup?.setProps({
                  getReferenceClientRect: props.clientRect,
                });
              },

              onKeyDown(props) {
                if (props.event.key === "Escape") {
                  popup?.hide();

                  return true;
                }

                return reactRenderer.ref?.onKeyDown(props);
              },

              onExit() {
                popup?.destroy();
                reactRenderer?.destroy();
              },
            };
          },
        }),
      ];
    },
  });
